export default __webpack_public_path__ + "static/media/bitcoin.597d75e2.svg";